import React from 'react';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import PropTypes from 'prop-types';
import { Avatar, Box, ListItem, Typography } from '@mui/material';
import { Fonts } from 'shared/constants/AppEnums';
import { stringAvatar } from 'shared/constants/AppEnums';

const NotificationItem = (props) => {
  const { item } = props;
  return (
    <ListItem
      sx={{
        padding: '8px 20px',
      }}
      className='item-hover'
      alignItems='flex-start'
    >
      <ListItemAvatar
        sx={{
          minWidth: 0,
          mr: 4,
          mt:0
        }}
      >
        {
          item.creator.avatar ? (
            <Avatar alt={item.creator.name} src={item.creator.avatar} />
          ) : (
            <Avatar {...stringAvatar(item.creator.name)} />
          )
        }
      </ListItemAvatar>
      <Box
        sx={{
          fontSize: 14,
          color: (theme) => theme.palette.text.secondary,
          overflow: 'hidden',
          wordBreak: 'break-word',
          whiteSpace: 'pre-line'
        }}
      >
        <Typography>
          <Box
            component='span'
            sx={{
              fontSize: 14,
              fontWeight: Fonts.MEDIUM,
              mb: 0.5,
              color: (theme) => theme.palette.text.primary,
              mr: 1,
              display: 'inline-block',
            }}
          >
            {item.creator.name}
          </Box>
          <Box dangerouslySetInnerHTML={{ __html: item.content }} component='span'>
          </Box>
        </Typography>
      </Box>
    </ListItem>
  );
};

export default NotificationItem;

NotificationItem.propTypes = {
  item: PropTypes.object.isRequired,
};
